//maps
(function($) {

    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$el (jQuery element)
    *  @return	n/a
    */
    
    function new_map( $el ) {
    
      // var
      var $markers = $el.find('.marker');
      var $markers2 = $el.find('.marker-2');
    
    
      // vars
      var args = {
          zoom		: 16,
          center		: new google.maps.LatLng(0, 0),
          mapTypeId	: google.maps.MapTypeId.ROADMAP
      };
    
    
      // create map
      var map = new google.maps.Map( $el[0], args);
    
    
      // add a markers reference
      map.markers = [];
      map.markers2 = [];
    
    
      // add markers
      $markers.each(function(){
    
          add_marker( $(this), map );
    
      });
    
      $markers2.each(function(){
    
          add_marker2( $(this), map );
    
      });
    
    
      // center map
      center_map( map );
    
    
      // return
      return map;
    
    }
    
    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */
    
    function add_marker( $marker, map ) {
    
      // var
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
      
    
      // Try to load custom icon, fallback to default if it fails
      var iconUrl = "/wp-content/themes/localmedia/symbols/marker.svg";
      
      // First try without custom icon to test if marker appears
      var marker = new google.maps.Marker({
          position	: latlng,
          map			: map
          // Temporarily remove custom icon to test basic marker
      });
      
      // Then try to apply custom icon if available
      var icon = {
          url: iconUrl,
          scaledSize: new google.maps.Size(32, 32),
          anchor: new google.maps.Point(16, 32),
          origin: new google.maps.Point(0, 0),
          size: new google.maps.Size(32, 32)
      };
      
      
      // Test if custom icon loads and apply it
      var testImg = new Image();
      testImg.onload = function() {
          marker.setIcon(icon);
      };
      testImg.onerror = function() {
          // Keep default marker (no custom icon)
      };
      testImg.src = iconUrl;
    
      // add to array
      map.markers.push( marker );
    
      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
          // create info window
          var infowindow = new google.maps.InfoWindow({
              content		: $marker.html()
          });
    
          // show info window when marker is clicked
          google.maps.event.addListener(marker, 'click', function() {
    
              infowindow.open( map, marker );
    
          });
      }
    
    }
    function add_marker2( $marker2, map ) {
    
      // var
      var latlng = new google.maps.LatLng( $marker2.attr('data-lat'), $marker2.attr('data-lng') );
    
    
      var icon = {
    
    
          url: "/wp-content/themes/localmedia-wp-theme/img/erledigte-projekte.svg",
          // path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
          // fillColor: '#FF0000',
          // fillOpacity: .6,
          // anchor: new google.maps.Point(0,0),
          // strokeWeight: 0,
          scale: 1
      }
    
      // create marker
      var marker = new google.maps.Marker({
          position	: latlng,
          map			: map,
          icon			: icon
      });
    
      // add to array
      map.markers.push( marker );
    
      // if marker contains HTML, add it to an infoWindow
      if( $marker2.html() )
      {
          // create info window
          var infowindow = new google.maps.InfoWindow({
              content		: $marker2.html()
          });
    
          // show info window when marker is clicked
          google.maps.event.addListener(marker, 'click', function() {
    
              infowindow.open( map, marker );
    
          });
      }
    
    }
    
    
    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */
    
    function center_map( map ) {
    
      // vars
      var bounds = new google.maps.LatLngBounds();
    
      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){
    
          var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    
          bounds.extend( latlng );
    
      });
    
      // only 1 marker?
      if( map.markers.length == 1 )
      {
          // set center of map
          map.setCenter( bounds.getCenter() );
          map.setZoom( 16 );
      }
      else
      {
          // fit to bounds
          //map.fitBounds( bounds );
          map.setCenter( bounds.getCenter() );
          map.setZoom( 9 );
      }
    
    }
    
    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	5.0.0
    *
    *  @param	n/a
    *  @return	n/a
    */
    // global var
    var map = null;
    
    // Initialize maps when Google Maps API is loaded
    function initializeMaps() {
        $('.acf-map').each(function(){
            // create map
            map = new_map( $(this) );
        });
    }
    
    // Wait for Google Maps API to load with async loading
    function waitForGoogleMaps() {
        if (typeof google !== 'undefined' && google.maps && google.maps.Map) {
            initializeMaps();
        } else {
            setTimeout(waitForGoogleMaps, 100);
        }
    }
    
    $(document).ready(function(){
        waitForGoogleMaps();
    });
    
    })(jQuery);